import React from 'react'
import {Nav} from 'react-bootstrap'
import {NavLink} from 'react-router-dom'
import "./SideMenu.scss";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBucket,
    faCog,
    faCreditCard,
    faHouseUser,
    faKey,
} from "@fortawesome/free-solid-svg-icons";
import {getSessionIsManagedByPartner} from "../../utils/auth";

const SideMenu = ({activeMenu}) => {
    return (
        <section>
            <Nav activeKey={activeMenu}>
                <NavLink exact to="/" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}><FontAwesomeIcon className="icon" icon={faHouseUser}/><span>Home</span></NavLink>
                <NavLink to="/buckets" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}><FontAwesomeIcon className="icon" icon={faBucket} /><span>Buckets</span></NavLink>
                <NavLink to="/access" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}><FontAwesomeIcon className="icon" icon={faKey} /><span>Access</span></NavLink>
                {!getSessionIsManagedByPartner() && <NavLink to="/billing" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}><FontAwesomeIcon className="icon" icon={faCreditCard} /><span>Billing</span></NavLink>}
                <NavLink to="/settings" className={({isActive}) => "nav-link" + (isActive ? " active" : "")}><FontAwesomeIcon className="icon" icon={faCog} /><span>Settings</span></NavLink>
            </Nav>
        </section>
    );
}

export default SideMenu;